// extracted by mini-css-extract-plugin
module.exports = {"search":"Search-module--search--3Jaft","icon":"Search-module--icon--17XZT","input":"Search-module--input--3PNfq"};